module.exports = __webpack_public_path__ + "static/password.253ecd3b.png";